module.exports = __webpack_public_path__ + "static/media/ContractOutgoingBIG.8cffaae9.svg";